import { render, staticRenderFns } from "./ChatCpn.vue?vue&type=template&id=0cd7335e&scoped=true"
import script from "./ChatCpn.vue?vue&type=script&lang=js"
export * from "./ChatCpn.vue?vue&type=script&lang=js"
import style0 from "./ChatCpn.vue?vue&type=style&index=0&id=0cd7335e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd7335e",
  null
  
)

export default component.exports